/**
 * ?from=indiv 会话级数据：订阅、实名、用户账户
 *
 * 订阅状态不在此文件内判断，统一由 subscriptionService.js 拉取 /status 并写入
 * subscriptionState；本模块只负责在合适时机触发 refreshSubscriptionStatus。
 */
import {
  refreshSubscriptionStatus,
  resetSubscriptionState,
  subscriptionState,
} from '@/view/user/subscriptionService/subscriptionService';
import {
  refreshRealnameStatus,
  resetRealnameState,
  realnameState,
} from '@/view/user/realname/realnameService';
import {
  refreshUserAccount,
  resetUserAccountState,
} from '@/view/user/userAccount/userAccountService';

/** 组装个人中心侧边栏所需快照（只读，不触发请求；active 由 /status 推导） */
export function getIndivSidebarSnapshot() {
  return {
    subscription: subscriptionState.status,
    active: subscriptionState.activeData,
    realname: realnameState.status,
  };
}

/**
 * 首次进入 indiv：并行拉取订阅、实名、用户账户（已 loaded 则跳过）
 * 订阅结果 → subscriptionState（见 subscriptionService.applySubscriptionStatus）
 */
export function bootstrapIndivSession(options = {}) {
  const { store = null } = options;
  return Promise.all([
    refreshRealnameStatus({ silent: true }),
    refreshSubscriptionStatus({ silent: true }),
    refreshUserAccount({ store }),
  ]);
}

/**
 * 业务变更后刷新 indiv 会话（试用领取 / 购买支付 / 实名成功等）
 * force=true 时会重新请求 GET /status，各页面读到的 subscriptionState 随之更新
 */
export function refreshIndivSession(options = {}) {
  const { force = true, store = null } = options;
  return Promise.all([
    refreshRealnameStatus({ silent: true, force }),
    refreshSubscriptionStatus({ silent: true, force }),
    refreshUserAccount({ force, store }),
  ]);
}

/** 退出登录：清空订阅、实名、用户账户缓存 */
export function resetIndivSession() {
  resetRealnameState();
  resetSubscriptionState();
  resetUserAccountState();
}

export { subscriptionState, realnameState };



// WEBPACK FOOTER //
// ./src/view/user/indivSession/indivSessionService.js